exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-cf0acd46] {\n  max-width: 350px;\n}\nbutton.md-button.btn-close[data-v-cf0acd46] {\n  background: #999 !important;\n}\n.load-vals[data-v-cf0acd46] {\n  display: inline-block;\n  width: calc(60% - 10px);\n  margin-right: 10px;\n}\n.load-vals[data-v-cf0acd46]::last-child {\n    margin-right: 0;\n}\n.load-vals span[data-v-cf0acd46] {\n    font-size: smaller;\n    margin-left: -12px;\n}\n", ""]);

// exports
